function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSettingsDeviceTypes = function SvgSettingsDeviceTypes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,24.25l.08-6.11a.89.89,0,0,1,.89-.89h0a.89.89,0,0,1,.89.89h0v6.11l-.89,1Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 21.25,
    width: 10,
    height: 5,
    rx: 1,
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.91,19.5H23a.75.75,0,0,1-.7-.47L22,18.25h6l-.28.71A.88.88,0,0,1,26.91,19.5Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,32.75v-7a2,2,0,0,1,2-2H34a2,2,0,0,1,2,2v7",
    style: {
      fill: "none",
      stroke: "#666",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettingsDeviceTypes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings-device-types.ab67a348.svg";
export { ForwardRef as ReactComponent };